import React, { createContext, useContext, useState, useCallback } from 'react';
import SignupModal from '../components/SignupModal';
import { useAuth } from './AuthContext';

/**
 * SignupModalContext — Point d'entrée UNIQUE pour la création de compte.
 * 
 * Fournit openSignupModal() à toute l'application.
 * Le SignupModal est rendu une seule fois au niveau App.
 * 
 * RÈGLE: Tout CTA "Créer un compte" / "S'inscrire" doit appeler openSignupModal()
 * et non navigate('/signup').
 */
const SignupModalContext = createContext();

export const useSignupModal = () => {
  const ctx = useContext(SignupModalContext);
  if (!ctx) throw new Error('useSignupModal must be used within SignupModalProvider');
  return ctx;
};

export const SignupModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useAuth();

  const openSignupModal = useCallback(() => {
    // Ne pas ouvrir si déjà connecté
    if (user) return;
    setIsOpen(true);
  }, [user]);

  const closeSignupModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <SignupModalContext.Provider value={{ openSignupModal, closeSignupModal, isSignupOpen: isOpen }}>
      {children}
      <SignupModal open={isOpen} onOpenChange={setIsOpen} />
    </SignupModalContext.Provider>
  );
};
